<template>
  <div class="product">
    <banner title="产品中心" subtitle="PRODUCTS & SOLUTIONS" />
    <div class="product-section" v-loading="loading">
      <div class="container">
        <div class="product-grid" v-if="productList.length">
          <router-link
            class="product-card"
            v-for="item in productList"
            :key="item.Id"
            :to="{ name: 'productdetails', params: { id: item.Id } }"
          >
            <div class="cover" v-lazy:background-image="$img(item.Img)"></div>
            <div class="body">
              <h3>{{ item.Title }}</h3>
              <p>{{ item.Summary || stripHtml(item.Content) }}</p>
              <span class="more">查看详情 <i class="el-icon-arrow-right"></i></span>
            </div>
          </router-link>
        </div>
        <div class="empty-tip" v-else-if="!loading">暂无产品，请先在后台添加。</div>

        <el-pagination
          v-if="productTotal > productPageSize"
          class="product-pager"
          layout="prev, pager, next, jumper, total"
          :page-size="productPageSize"
          :current-page.sync="productPage"
          :total="productTotal"
          background
        />
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  components: { Banner },
  data() {
    return {
      loading: true,
      productList: [],
      productPage: 1,
      productPageSize: 6,
      productTotal: 0
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    productPage() {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$http
        .get(`Product/Page?page=${this.productPage}&size=${this.productPageSize}`)
        .then(response => {
          const data = response.data || {};
          this.productList = data.Items || data.items || [];
          this.productTotal = data.Total || data.total || 0;
          this.loading = false;
        })
        .catch(() => {
          this.productList = [];
          this.productTotal = 0;
          this.loading = false;
        });
    },
    stripHtml(html) {
      if (!html) return "";
      const text = String(html).replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
      return text.length > 70 ? text.slice(0, 70) + "..." : text;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.product {
  width: 100%;
  background: $color-bg-2;
  padding-bottom: 60px;
}

.product-section {
  padding: 28px 0 0;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
}

.product-card {
  border: 1px solid $color-border;
  background: #fff;
  display: flex;
  flex-direction: column;
  color: $color-text;
  transition: border-color 0.2s ease;
  // grid item 显式 min-width:0,避免被内部 h3 长标题撑大(默认 min-width:auto = min-content)
  min-width: 0;

  &:hover {
    border-color: $color-accent;
    color: $color-accent;

    .more { color: $color-accent-dark; }
  }

  .cover {
    height: 180px;
    background: #e8e8e8 center / cover no-repeat;
    border-bottom: 1px solid $color-border;
  }

  .body {
    padding: 18px 24px 16px;
    flex: 1;
    display: flex;
    flex-direction: column;

    h3 {
      margin: 0;
      font-size: 17px;
      color: $color-text;
      line-height: 1.4;
      font-weight: 600;
    }

    p {
      margin: 10px 0 14px;
      min-height: 66px;
      color: $color-text-2;
      font-size: 13px;
      line-height: 1.75;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .more {
      margin-top: auto;
      color: $color-accent;
      text-decoration: none;
      font-size: 13px;
      display: inline-flex;
      align-items: center;
      gap: 4px;
    }
  }
}

.empty-tip {
  text-align: center;
  color: $color-text-3;
  padding: 60px 0;
  background: #fff;
  border: 1px solid $color-border;
}

.product-pager {
  padding: 24px;
  text-align: center;
}

@media (max-width: 960px) {
  .product-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px; }
}

@media (max-width: 640px) {
  .product-grid { grid-template-columns: 1fr; }
}
</style>
